import { SingleAsset } from 'components/Web2Publish/components/SingleAsset';

const ScreenSingleAsset = () => {
  return <SingleAsset />;
};

export default ScreenSingleAsset;
